import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
    FormControlLabel,
    Grid,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText
} from '@material-ui/core';

import { GUIDE_TYPE } from 'yeself-common/ModelConstant';

import FormCheckbox from 'Console/components/common/form/FormCheckbox';

const styles = (theme) => ({
    formItemSelect: {
        width: '37%',
        paddingRight: theme.typography.pxToRem(21),
        paddingLeft: theme.typography.pxToRem(18),
        [theme.breakpoints.down('md')]: {
            width: '100%',
            marginTop: theme.typography.pxToRem(15),
            marginBottom: theme.typography.pxToRem(30),
            paddingLeft: 0,
            marginLeft: 0,
        },
    },
    selectBox: {
        paddingLeft: theme.typography.pxToRem(35),
    },
    tab: {
        paddingRight: theme.typography.pxToRem(30),
        paddingLeft: theme.typography.pxToRem(30),
        [theme.breakpoints.between('xs', 'md')]: {
            paddingRight: theme.typography.pxToRem(0),
            paddingLeft: theme.typography.pxToRem(0),
        },
    },
});

const GuideGeneralTab = ({
    form,
    guide: { type, subType },
    initialValues,
    classes,
}) => {
    const { getFieldValue } = form;

    return (
        <Grid container>
            <Grid container direction="column" className={classes.tab}>
                <Grid item xs={12} md={6} lg={5}>
                    <List disablePadding>
                        <ListItem>
                            <ListItemText
                                primary={
                                    <FormattedMessage
                                        id="SettingsGeneral.field.published"
                                        defaultMessage="published"
                                    />
                                }
                                secondary={
                                    <FormattedMessage
                                        id="SettingsGeneral.elfHint.sandbox"
                                        defaultMessage="Guide is visible by end users"
                                    />
                                }
                            />
                            <ListItemSecondaryAction>
                                <FormControlLabel
                                    control={
                                        <FormCheckbox
                                            form={form}
                                            initialValue={getFieldValue('sandbox') ?? initialValues.sandbox}
                                            formItemKey="sandbox"
                                        />
                                    }
                                />
                            </ListItemSecondaryAction>
                        </ListItem>

                        {type === GUIDE_TYPE.TOUR && !subType ? (
                            <ListItem>
                                <ListItemText
                                    primary={
                                        <FormattedMessage
                                            id="Guides.startAutomatically"
                                            defaultMessage="Start the guide automatically"
                                        />
                                    }
                                />
                                <ListItemSecondaryAction>
                                    <FormControlLabel
                                        control={
                                            <FormCheckbox
                                                initialValue={getFieldValue('startAutomatically') || initialValues.startAutomatically}
                                                form={form}
                                                formItemKey="startAutomatically"
                                            />
                                        }
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                        ) : null}
                    </List>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default withStyles(styles)(injectIntl(GuideGeneralTab));
